var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export-to-csv"},[_c('v-btn',{attrs:{"rounded":"","color":"primary","x-large":""},on:{"click":function($event){return _vm.csvExport(_vm.data)}}},[_vm._v("Export to CSV")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }